export const getImproveDeveloperExperienceData = (improved, defaultData) => {
  return window.LFApp?.improveDeveloperExperience ? improved : defaultData;
}